import { render } from "./EditMetadataModal.vue?vue&type=template&id=737df036"
import script from "./EditMetadataModal.vue?vue&type=script&lang=js"
export * from "./EditMetadataModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__